<template>
  <section class="swiper band highlight">
    <!--
      [D] 신규 div 처리
      - 기존 CommonBand에도 동일한 처리 완료
      - 해당 div에 blur 처리된 bgimg 삽입 필요
       -->
    <div class="background" aria-hidden="true" :style="'background-image: url(' + blurImage + ')'" v-if="!isLoading">강조형 밴드 배경 이미지 영역</div>
    <div class="foreground">
      <div class="band-title-wrap">
        <!-- [D] 신규 텍스트형 제목: 분기 필요 -->
        <h1 class="text-title">
          <span tabindex="0" class="band-title" v-if="hasTitle(0)">{{ getTitleText(0) }}</span>
          <span tabindex="0" class="band-title" v-if="hasTitle(1)">{{ getTitleText(1) }}</span>
        </h1>

        <!-- [D] 신규 로고형 제목: 분기 필요 => 다음 차수 로고 타이틀 추가
        <h1 class="logo-title">
          <img src="@/assets/images/@temp/logo-title.png" alt="로고형 밴드 샘플">
        </h1>
          -->
        <!-- [D] 신규 서브타이틀 -->
        <p tabindex="0" class="band-subtitle" v-if="hasTitle(2)">{{ getTitleText(2) }}</p>
        <p tabindex="0" class="band-subtitle" v-if="hasTitle(3)">{{ getTitleText(3) }}</p>

        <a href="#" class="link-band-list" @click.prevent="goDetail">{{ cta }}</a>
      </div>

      <ul class="swiper-wrapper portrait" v-if="cellList.length > 0">
        <portrait-cell v-for="(cellInfo, index) in cellList" :cell-info="cellInfo" :cell-index="index"
                       :thumbnail-info="thumbnailInfo" :key="index"></portrait-cell>
      </ul>
    </div>
  </section>
</template>
<script>
import { get } from 'lodash'
import PortraitCell from '@/components/section/template/cell/PortraitCell'
import { EventService } from '@/common/api/api.service'
import EventModelClass from '@/common/model/EventModelClass'
import { routeToList } from '@/common/util/common'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import { resizeThumbnail } from '@/common/image.filter'

export default {
  name: 'HighlightBand',
  components: { PortraitCell },
  props: {
    sectionInfo: {
      type: Object
    }
  },
  data () {
    return {
      cellList: [],
      cta: '더보기',
      blurImage: '',
      titleList: [],
      thumbnailInfo: {},
      isLoading: false
    }
  },
  methods: {
    setData () {
      this.isLoading = true
      EventService.requestEventData(new EventModelClass(this.sectionInfo.contentEvent)).then(({ data }) => {
        this.cellList = get(data, 'band.celllist', [])
        this.cta = get(data, 'cell_toplist.cta', '더보기')
        this.setBlurImage(get(data, 'cell_toplist.blurtarget_img', ''))
        this.titleList = get(data, 'cell_toplist.title_list', [])
        this.thumbnailInfo = getBandTypeInfoByCellType('Band14')
        this.isLoading = false
      })
    },
    setBlurImage (image) {
      const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      const portrait = get(window.matchMedia('(orientation: portrait)'), 'matches', false)
      if (w >= 768 && w <= 1366) {
        if (portrait) {
          this.blurImage = resizeThumbnail(image, { width: 1000, height: 340, option: 'b20', quality: 100 })
        } else {
          this.blurImage = resizeThumbnail(image, { width: 1342, height: 371, option: 'b20', quality: 100 })
        }
      } else {
        this.blurImage = resizeThumbnail(image, { width: 390, height: 432, option: 'b20', quality: 100 })
      }
    },
    goDetail () {
      routeToList(this.sectionInfo, this.$route)
    },
    getTitleText (index) {
      return get(this.titleList, `${index}.text`, '')
    },
    hasTitle (index) {
      return this.getTitleText(index) !== ''
    }
  },
  created () {
    this.setData()
  }
}
</script>
